export default "__VITE_ASSET__59753d6d__"